import { createSelector } from 'reselect';
import { USER_STORE_KEY, UserSliceNames } from '~/modules/user/redux/user.store';

const selectUserState = state => state[USER_STORE_KEY];

export const selectUser = createSelector(selectUserState, store => store[UserSliceNames.user].value);
